export enum MerchantType {
    WePay = 0,
    Stripe = 1,
    Virtuous = 2,
    StripeUnified = 3,
    PayPal = 4,
}
